export default "__VITE_ASSET__BZhC3h9c__"